import React, { useState } from 'react';
import { Menu } from 'lucide-react';
import { useSidebar } from '../../contexts/SidebarContext';
import { useBranding } from '../../contexts/BrandingContext';
import { useAppFeatures } from '../../contexts/AppFeaturesContext';
import NotificationBell from '../Notifications/NotificationBell';
import NotificationBottomSheet from '../Notifications/NotificationBottomSheet';

const MobileHeader: React.FC = () => {
  const { isMobile, openMobile } = useSidebar();
  const { config: brandingConfig } = useBranding();
  const appFeatures = useAppFeatures();
  const [isNotifOpen, setIsNotifOpen] = useState(false);

  if (!isMobile) return null;

  return (
    <>
      <div className="mobile-header">
        <button
          className="mobile-header__hamburger"
          onClick={openMobile}
          aria-label="Открыть меню"
        >
          <Menu size={22} />
        </button>
        <div className="mobile-header__logo">
          <div className="mobile-header__logo-mark">
            <img src={brandingConfig?.logo_url || '/favicon.svg'} alt="" width={24} height={24} />
          </div>
          <span className="mobile-header__logo-title">
            {brandingConfig ? (
              brandingConfig.app_name
            ) : (
              <>Assistant <span className="text-primary-600">Business</span></>
            )}
          </span>
        </div>
        {appFeatures.notifications && (
          <NotificationBell
            variant="mobile"
            isOpen={isNotifOpen}
            onClick={() => setIsNotifOpen(true)}
          />
        )}
      </div>
      {appFeatures.notifications && isNotifOpen && (
        <NotificationBottomSheet
          onClose={() => setIsNotifOpen(false)}
        />
      )}
    </>
  );
};

export default MobileHeader;
